<template>
  <div class="app-container">
    <div class="filter-container">
      <el-form :inline="true" label-position="top" label-width="100px" class="custom-form">
        <el-form-item :label="$t('member.memberName')" class="custom-item">
          <el-input
            :placeholder="$t('member.memberName')"
            v-model="listQuery.memberName"
            class="filter-item"
          />
        </el-form-item>
        <el-form-item :label="$t('member.cardNo')" class="custom-item">
          <el-input
            :placeholder="$t('member.cardNo')"
            v-model="listQuery.cardNo"
            class="filter-item"
          />
        </el-form-item>
        <el-form-item :label="$t('record.shiftNo')" class="custom-item">
          <el-input
            :placeholder="$t('record.shiftNo')"
            v-model="listQuery.classes"
            class="filter-item"
          />
        </el-form-item>
        <el-form-item :label="$t('record.fuelOrderId')" class="custom-item">
          <el-input
            :placeholder="$t('record.fuelOrderId')"
            v-model="listQuery.fuelOrderId"
            class="filter-item"
          />
        </el-form-item>
        <el-form-item label="加油站点" class="custom-item">
          <el-select
            v-model="listQuery.stationId"
            placeholder="加油站点"
            class="filter-item"
            @change="selectStation"
          >
            <el-option v-if="isAllStation === 1" label="全部" value />
            <el-option
              v-for="(item, index) in stationLists"
              :key="index"
              :label="item.stationName"
              :value="item.stationId"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('record.fpNo')" class="custom-item">
          <!--<el-input :placeholder="$t('record.fpNo')" v-model="listQuery.fpNo" class="filter-item"/>-->
          <el-select v-model="listQuery.fpNo" :placeholder="$t('record.fpNo')" class="filter-item">
            <el-option label="全部" value />
            <el-option
              v-for="item in fpList"
              :key="item.key"
              :label="item.fpNo"
              :value="item.fpNo"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('company.companyName')" class="custom-item">
          <el-select
            v-model="listQuery.companyId"
            :placeholder="$t('company.companyName')"
            class="filter-item"
          >
            <el-option label="全部" value />
            <el-option
              v-for="item in companyLists"
              :key="item.key"
              :label="item.companyName"
              :value="item.companyId"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('company.payType')" class="custom-item">
          <el-select
            v-model="listQuery.payTypeId"
            :placeholder="$t('company.payType')"
            class="filter-item"
          >
            <el-option label="全部" value />
            <el-option
              v-for="(item, index) in payLists"
              :key="index"
              :label="item.payTypeName"
              :value="item.payTypeId"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('table.status')" class="custom-item">
          <el-select
            v-model="listQuery.payStatus"
            :placeholder="$t('table.status')"
            class="filter-item"
          >
            <el-option label="全部" value />
            <el-option
              v-for="(item, index) in statusType"
              :key="index"
              :label="item"
              :value="index"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="加油类型" prop="stationName" class="custom-item">
          <el-select v-model="listQuery.orderType" placeholder="加油类型">
            <template v-for="item in fuelTypeArr">
              <el-option v-for="(value, key) in item" :label="value" :value="key" :key="key" />
            </template>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('table.date')" class="custom-item">
          <el-date-picker
            v-model="btime"
            :default-time="['00:00:00','23:59:59']"
            type="datetimerange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
          />
        </el-form-item>
        <el-form-item label="快速选择时间" class="custom-item">
          <el-select v-model="quickTime" placeholder="时间" @change="changeVal">
            <el-option label="今天" value="1" />
            <el-option label="昨天" value="2" />
            <el-option label="近三天" value="3" />
            <el-option label="近七天" value="4" />
            <el-option label="本月" value="5" />
          </el-select>
        </el-form-item>
        <el-form-item label="车牌号" class="custom-item">
          <el-input v-model="listQuery.carNo" placeholder="请输入车牌号" class="filter-item" />
        </el-form-item>
      </el-form>
      <p style="text-align:center">
        <el-button
          v-waves
          class="filter-item"
          type="info"
          icon="el-icon-document"
          @click="handleFuelToExcel"
        >导出</el-button>
        <el-button
          v-waves
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          @click="handleFilter"
        >{{ $t("table.search") }}</el-button>
      </p>
    </div>
    <el-row>
      <el-col :offset="16">
        <h3>
          笔数：{{ total }}&nbsp;&nbsp;升数：{{
            totalVol
          }}&nbsp;&nbsp;实收金额：{{ totalMoney }}&nbsp;&nbsp;应收金额：{{
            totalReceAmt
          }}
        </h3>
      </el-col>
    </el-row>
    <el-table
      v-loading="listLoading"
      :key="tableKey"
      :data="list"
      border
      fit
      highlight-current-row
      style="width: 100%;"
    >
      <el-table-column :label="$t('record.fpNo')" align="center" min-width="60px">
        <template slot-scope="scope">
          <span>{{ scope.row.fpNo }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('record.prodName')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.prodName }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('record.price')" align="center" min-width="60px">
        <template slot-scope="scope">
          <span>{{ scope.row.price }}</span>
        </template>
      </el-table-column>
      <el-table-column label="升数" align="center" min-width="80px">
        <template slot-scope="scope">
          <span>{{ scope.row.vol }}</span>
        </template>
      </el-table-column>
      <el-table-column label="金额" align="center" min-width="80px">
        <template slot-scope="scope">
          <span>{{ scope.row.receAmt }}</span>
        </template>
      </el-table-column>
      <el-table-column label="实收金额" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.realAmt }}</span>
        </template>
      </el-table-column>
      <el-table-column label="优惠金额" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.discAmt }}</span>
        </template>
      </el-table-column>
      <el-table-column label="车牌号" align="center" min-width="120px">
        <template slot-scope="scope">
          <span>{{ scope.row.memberCarNo }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('record.shiftNo')" align="center" min-width="120px">
        <template slot-scope="scope">
          <span>{{ scope.row.classes }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('record.payStatus')" align="center" min-width="80px">
        <template slot-scope="scope">
          <span>{{ scope.row.payStatus | statusFilter }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('record.payTypeName')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.payTypeName | payTypeFilter }}</span>
        </template>
      </el-table-column>
      <el-table-column label="站点" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.stationName }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('record.createdTime')" align="center" min-width="150px">
        <template slot-scope="scope">
          <span>{{ scope.row.createdTime }}</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('table.actions')"
        align="center"
        min-width="60px"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <span style="color: #409eff;cursor: pointer;" @click="handleUpdate(scope.row)">查看</span>
          &nbsp;
          <span
            style="color: #409eff;cursor: pointer;"
            @click="doPrint(scope.row)"
          >小票</span>
        </template>
        <!--        <template slot-scope="scope">
          <span style="color: #409eff;cursor: pointer;" @click="doPrint(scope.row)">小票</span>
        </template>-->
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-dialog :visible.sync="dialogFormVisible" title="订单详情" width="880px">
      <el-form
        :inline="true"
        :model="temp"
        class="demo-form-inline"
        label-position="right"
        label-width="110px"
        style="width: 100%;margin-left: 10%"
      >
        <el-form-item>
          <label class="title">订单ID</label>
          <span class="one">{{ temp.fuelOrderId }}</span>
          <label>总部名</label>
          <span class="two">{{ temp.groupName }}</span>
          <label>站点名</label>
          <span class="two">{{ temp.stationName }}</span>
        </el-form-item>
        <el-form-item>
          <label>提枪时间</label>
          <span class="one">{{ temp.fpStartTime }}</span>
          <label>油枪号</label>
          <span class="two">{{ temp.fpNo }}</span>
          <label>油品名</label>
          <span class="two">{{ temp.prodName }}</span>
        </el-form-item>
        <el-form-item>
          <label>挂枪时间</label>
          <span class="one">{{ temp.fpEndTime }}</span>
          <label>升数</label>
          <span class="two">{{ temp.vol }}</span>
          <label>单价</label>
          <span class="two">{{ temp.price }}</span>
        </el-form-item>
        <el-form-item>
          <label>累计升数</label>
          <span class="one">{{ temp.totalVol }}</span>
          <label>累计金额</label>
          <span class="two">{{ temp.totalAmt }}</span>
          <label>会员ID</label>
          <span class="two">{{ temp.memberId }}</span>
        </el-form-item>
        <el-form-item>
          <label>会员名</label>
          <span class="one">{{ temp.memberName }}</span>
          <label>车牌号</label>
          <span class="two">{{ temp.memberCarNo }}</span>
          <label>班次号</label>
          <span class="two">{{ temp.classes }}</span>
        </el-form-item>
        <el-form-item>
          <label>支付方式</label>
          <span class="two">{{ temp.payTypeName }}</span>
          <label>员工姓名</label>
          <span class="one">{{ temp.empName }}</span>
          <label>收银员ID</label>
          <span class="two">{{ temp.cashierEmpId }}</span>
        </el-form-item>
        <el-form-item>
          <label>支付状态</label>
          <span class="two">{{ temp.payStatus | statusFilter }}</span>
          <label>实收金额</label>
          <span class="one">{{ temp.realAmt }}</span>
          <label>优惠金额</label>
          <span class="two">{{ temp.discAmt }}</span>
        </el-form-item>
        <el-form-item>
          <label>应收金额</label>
          <span class="two">{{ temp.receAmt }}</span>
          <label>支付时间</label>
          <span class="one">{{ temp.payTime }}</span>
          <label>创建时间</label>
          <span class="two">{{ temp.createdTime }}</span>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :visible.sync="dialogPvVisible" title="Reading statistics">
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogPvVisible = false">
          {{
            $t("table.confirm")
          }}
        </el-button>
      </span>
    </el-dialog>
    <div ref="miniTicketPrint">
      <div v-if="printTicket" ref="printTicketContent">
        <table
          class="miniTicket"
          style="width: auto;height: auto;"
          border="0px"
          cellspacing="0"
          cellpadding="0"
        >
          <tr>
            <td style="font-size: 1px;font-family: 黑体">&nbsp;&nbsp;&nbsp;&nbsp;支付凭证</td>
          </tr>
          <tr>
            <td style="font-size: 3px;font-family: 黑体">
              <a>&nbsp;</a>
            </td>
          </tr>
          <tr>
            <td
              style="font-size: 1px;font-family: 黑体"
            >&nbsp;&nbsp;订单:{{ miniTicketData.fuelOrderId }}</td>
          </tr>
          <tr>
            <td style="font-size: 3px;font-family: 黑体">&nbsp;&nbsp;加油员:{{ miniTicketData.empName }}</td>
          </tr>
          <tr>
            <td
              style="font-size: 3px;font-family: 黑体"
            >&nbsp;&nbsp;加油员卡号:{{ miniTicketData.empCardNo }}</td>
          </tr>
          <tr>
            <td
              style="font-size: 3px;font-family: 黑体"
            >&nbsp;&nbsp;加油时间:{{ miniTicketData.createdTime }}</td>
          </tr>
          <tr>
            <td style="font-size: 3px;font-family: 黑体">&nbsp;&nbsp;油枪号:{{ miniTicketData.fpNo }}</td>
          </tr>
          <tr>
            <td style="font-size: 3px;font-family: 黑体">&nbsp;&nbsp;油品:{{ miniTicketData.prodName }}</td>
          </tr>
          <tr>
            <td style="font-size: 3px;font-family: 黑体">&nbsp;&nbsp;单价:{{ miniTicketData.price }}元/升</td>
          </tr>
          <tr>
            <td style="font-size: 3px;font-family: 黑体">&nbsp;&nbsp;升数:{{ miniTicketData.vol }}升</td>
          </tr>
          <tr>
            <td style="font-size: 3px;font-family: 黑体">&nbsp;&nbsp;金额:{{ miniTicketData.receAmt }}元</td>
          </tr>
          <tr>
            <td style="font-size: 3px;font-family: 黑体">&nbsp;&nbsp;支付时间:{{ miniTicketData.payTime }}</td>
          </tr>
          <tr>
            <td
              style="font-size: 3px;font-family: 黑体"
            >&nbsp;&nbsp;实收金额:{{ miniTicketData.realAmt }}元</td>
          </tr>
          <tr>
            <td
              style="font-size: 3px;font-family: 黑体"
            >&nbsp;&nbsp;优惠金额:{{ miniTicketData.discAmt }}元</td>
          </tr>
          <tr>
            <td style="font-size: 3px;font-family: 黑体">&nbsp;&nbsp;余额:{{ miniTicketData.balance }}元</td>
          </tr>
          <tr>
            <td
              style="font-size: 3px;font-family: 黑体"
            >&nbsp;&nbsp;支付方式：{{ miniTicketData.payTypeName }}</td>
          </tr>
          <tr>
            <td
              style="font-size: 3px;font-family: 黑体"
            >&nbsp;&nbsp;会员姓名:{{ miniTicketData.memberName }}</td>
          </tr>
          <tr>
            <td
              style="font-size: 3px;font-family: 黑体"
            >&nbsp;&nbsp;会员卡号:{{ miniTicketData.memberCardNo }}</td>
          </tr>
          <tr>
            <td style="font-size: 3px;font-family: 黑体">
              <a>&nbsp;</a>
            </td>
          </tr>
          <tr>
            <td style="text-align: center;font-size: 4px;font-family: 黑体">----欢迎下次光临----</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchFuel, fetchTotalFuel } from '@/api/record'
import { fuelRecordToExcel } from '@/api/download'
import { memberList } from '@/api/member'
import { gradeList } from '@/api/grade'
import { listStationSimple, listFp } from '@/api/station'
import { fetchList } from '@/api/company'
import { listPayType } from '@/api/setting'
import waves from '@/directive/waves' // 水波纹指令
import { checkRate } from '@/utils/validate'
import { getDateOfDay, getYesterdayArr, getCurMonthRange } from '../../utils'
import { downloadFile } from '@/utils/file'
import { getEmpInfo } from '@/utils/auth'
import createUniqueString from '@/utils/createUniqueString'
import Print from '@/utils/print'
import Vue from 'vue'
Vue.use(Print) // 注册
const typeOptions = [
  { value: 1, label: '总帐支付' },
  { value: 2, label: '子账支付' }
]
const statusMap = { 0: '未支付', 1: '已支付' }
const fuelStatus = [{ '0': '员工' }, { '1': '客户' }, { '-1': '全部' }]
export default {
  name: 'ComplexTable',
  directives: {
    waves
  },
  filters: {
    statusFilter (status) {
      return statusMap[status]
    },
    typeFilter (type) {
      for (const key in typeOptions) {
        if (typeOptions[key].value === type) {
          return typeOptions[key].label
        }
      }
    },
    payTypeFilter (type) {
      if(type){
        if (type.toString().indexOf('余额') !== -1) {
          return '余额'
        }else{
          return type
        }
      }else{
        return ''
      }
    }
  },
  data () {
    return {
      btime: getDateOfDay(0),
      tableKey: 0,
      stationLists: [],
      fpList: [],
      list: null,
      total: null,
      listLoading: true,
      fuelTypeArr: fuelStatus,
      totalVol: 0,
      totalMoney: 0,
      totalReceAmt: 0,
      listQuery: {
        page: 1,
        limit: 20,
        payStatus: '',
        title: '',
        companyId: '',
        memberGradeId: '',
        stationId:
          getEmpInfo().isAllStation === 0 ? getEmpInfo().stationId : '',
        cardNo: '',
        classes: '',
        fpNo: '',
        memberName: '',
        payTypeId: '',
        fuelOrderId: '',
        orderType: '-1',
        random: ''
      },
      isAllStation: getEmpInfo().isAllStation,
      showReviewer: false,
      temp: {
        fuelOrderId: '',
        groupName: '',
        stationName: '',
        fpNo: '',
        prodName: '',
        fpStartTime: '',
        fpEndTime: '',
        realAmt2: '',
        price: '',
        totalVol: '',
        totalAmt: '',
        memberId: '',
        memberName: '',
        memberCarNo: '',
        shiftNo: '',
        empName: '',
        tem: '',
        payStatus: '',
        realAmt: '',
        discAmt: '',
        tem2: '',
        payTypeName: '',
        payTime: '',
        createdTime: '',
        classes: ''
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '添加'
      },
      dialogPvVisible: false,
      types: typeOptions,
      statusType: statusMap,
      rules: {
        companyName: [
          { required: true, message: '必须填写', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        contactName: [
          { required: true, message: '必须填写', trigger: 'blur' },
          {
            min: 2,
            max: 100,
            message: '长度在 2 到 50 个字符',
            trigger: 'blur'
          }
        ],
        contactPhone: [
          { required: true, message: '必须填写', trigger: 'blur' },
          { min: 8, max: 20, message: '长度在 8 到 20 个字符', trigger: 'blur' }
        ],
        memberGradeName: [
          { required: true, message: '必须填写', trigger: 'change' }
        ],
        companyType: [
          { required: true, message: '必须填写', trigger: 'change' }
        ],
        creditAmt: [{ required: true, message: '必须填写', trigger: 'blur' }]
      },
      payLists: [],
      gradeLists: [],
      companyLists: [],
      quickTime: '',
      printTicket: false,
      miniTicketData: {
        fuelOrderId: '',
        empName: '',
        empCardNo: '',
        createdTime: '',
        fpNo: '',
        prodName: '',
        price: '',
        vol: '',
        receAmt: '',
        payTime: '',
        realAmt: '',
        discAmt: '',
        balance: '',
        payTypeName: '',
        memberName: '',
        memberCardNo: ''
      }
    }
  },
  created () {
    gradeList({}).then(response => {
      const row = response.data
      if (row.data) {
        const obj = row.data
        for (const key in obj) {
          this.gradeLists.push({
            gradeId: obj[key].gradeId,
            gradeName: obj[key].gradeName
          })
        }
      }
    })
    listPayType({ status: 1 }).then(response => {
      const row = response.data
      if (row.data) {
        const obj = row.data
        for (const key in obj) {
          this.payLists.push({
            payTypeId: obj[key].payTypeId,
            payTypeName: obj[key].payTypeName
          })
        }
      }
    })
    listStationSimple({ ps: 100 }).then(response => {
      const row = response.data
      if (row.data) {
        const obj = row.data
        for (const key in obj) {
          this.stationLists.push({
            stationId: obj[key].stationId,
            stationName: obj[key].stationName
          })
        }
        if (this.stationLists.length === 1) {
          this.selectStation(this.stationLists[0].stationId)
        }
      }
    })
    fetchList({ ps: 100 }).then(response => {
      const row = response.data
      if (row.data.items) {
        const obj = row.data.items
        for (const key in obj) {
          this.companyLists.push({
            companyId: obj[key].companyId,
            companyName: obj[key].companyName
          })
        }
      }
    })
    this.handleFilter()
  },
  methods: {
    querySearchAsync (queryString, cb) {
      const results = queryString ? this.memberList() : this.restaurants
      const res = []
      for (const key in results) {
        res.push({
          value: results[key].memberName,
          memberId: results[key].memberId
        })
      }
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        cb(res)
      }, 3000 * Math.random())
    },
    handleSelect (item) {
      this.listQuery.memberId = item.memberId
      this.listQuery.memberName = item.value
    },
    memberList () {
      this.listLoading = true
      this.listQuery['memberGradeId'] = this.listQuery.memberGradeId
      this.listQuery['stationId'] = this.listQuery.stationId
      this.listQuery['pi'] = this.listQuery.page
      this.listQuery['ps'] = this.listQuery.limit
      memberList(this.listQuery).then(response => {
        this.listLoading = false
        const row = response.data
        if (row.data) {
          this.restaurants = row.data.items
          return row.data.items
        }
        return []
      })
    },
    getList () {
      this.listLoading = true
      this.listQuery['pi'] = this.listQuery.page
      this.listQuery['ps'] = this.listQuery.limit
      if (checkRate(this.listQuery.title)) {
        this.listQuery.memberId = this.listQuery.title
      }
      // else this.listQuery.memberName = this.listQuery.title
      if (this.btime) {
        this.listQuery.beginTime = this.btime[0]
        this.listQuery.endTime = this.btime[1]
      }
      this.listQuery.random = createUniqueString()
      fetchFuel(this.listQuery).then(response => {
        const row = response.data
        if (row.data) {
          this.list = row.data.items
          this.total = row.data.totalItems
        }
        // Just to simulate the time of the request
        this.listLoading = false
      })
    },
    handleFilter () {
      fetchTotalFuel(this.listQuery).then(resp => {
        if (!resp.data) {
          this.totalVol = 0
          this.totalMoney = 0
          this.totalReceAmt = 0
        } else {
          this.totalMoney = resp.data.data.totalAmt
          this.totalVol = resp.data.data.totalVol
          this.totalReceAmt = resp.data.data.totalRece
        }
      })
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange (val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.listQuery.page = val
      this.getList()
    },
    handleUpdate (row) {
      this.temp = Object.assign({}, row)
      this.dialogFormVisible = true
    },
    selectStation (val) {
      this.listQuery.fpNo = ''
      this.fpList = []
      if (val) {
        listFp({ stationId: val }).then(resp => {
          const fpData = resp.data.data
          this.fpList = fpData.items
        })
      } else {
        listFp({ stationId: '' }).then(resp => {
          const fpData = resp.data.data
          this.fpList = fpData.items
        })
      }
    },
    handleFuelToExcel () {
      let loadingIns
      this.$confirm('确定导出加油记录为excel吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        loading: true,
        type: 'info'
      })
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          loadingIns = loading
          console.log(this.listQuery)

          fuelRecordToExcel(this.listQuery)
            .then(response => {
              if (response.data) {
                const type = response.headers['content-type']
                // response.setHeader("Content-Type", "application/vnd.ms-excel"); type必须和后端的type一致
                downloadFile(response, type)
                loadingIns.close()
              }
            })
            .catch(e => {
              this.$message({
                type: 'warning',
                message: '导出失败！ 原因：' + e
              })
              loadingIns.close()
            })
        })
        .catch(() => {
          this.$message({
            type: 'warning',
            message: '取消导出！'
          })
          loadingIns.close()
        })
    },
    changeVal (val) {
      switch (val) {
        case '1':
          this.btime = getDateOfDay(0)
          break
        case '2':
          this.btime = getYesterdayArr()
          break
        case '3':
          this.btime = getDateOfDay(-3)
          break
        case '4':
          this.btime = getDateOfDay(-7)
          break
        case '5':
          this.btime = getCurMonthRange()
          break
        default:
          this.btime = getDateOfDay(0)
          break
      }
    },
    doPrint (row) {
      // this.$print('<div>hello world !</div>')
      this.miniTicketData = {
        fuelOrderId: '',
        empName: '',
        empCardNo: '',
        createdTime: '',
        fpNo: '',
        prodName: '',
        price: '',
        vol: '',
        receAmt: '',
        payTime: '',
        realAmt: '',
        discAmt: '',
        balance: '',
        payTypeName: '',
        memberName: '',
        memberCardNo: ''
      }
      const balance = row.balance
      let balanceValue = '---'
      if (typeof balance !== 'undefined') {
        console.log('balance %s type %s .', balance, typeof balance)
        balanceValue = balance
      }
      this.miniTicketData = {
        fuelOrderId: row.fuelOrderId,
        empName: row.empName,
        empCardNo: row.empCardNo,
        createdTime: row.createdTime,
        fpNo: row.fpNo,
        prodName: row.prodName,
        price: row.price,
        vol: row.vol,
        receAmt: row.receAmt,
        payTime: row.payTime,
        realAmt: row.realAmt,
        discAmt: row.discAmt,
        balance: balanceValue,
        payTypeName: row.payTypeName,
        memberName: row.memberName,
        memberCardNo: row.memberCardNo
      }
      this.printTicket = true
      setTimeout(this.printing, 10)
    },
    printing () {
      const newWindow = window.open('打印窗口', '_blank')
      const docStr = this.$refs['miniTicketPrint'].innerHTML
      newWindow.document.write(docStr)
      newWindow.document.close()
      newWindow.print()
      newWindow.close()
      /*    this.$print(this.$refs['miniTicketPrint'])*/
      this.printTicket = false
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.el-form-item__content span,
.el-form-item__content label {
  display: inline-block;
}
.el-form-item__content label {
  width: 90px;
  text-align: center;
  background-color: #f2f6fc;
}
.el-form-item__content span.one {
  width: 195px;
}
.el-form-item__content span.two {
  width: 140px;
}
.miniTicket {
  font-size: 10px;
  font-family: 楷体;
}
</style>
